"use client";
import { SyncHandoff } from "./SyncHandoff";

interface Props {
  themeId: string;
  chatId: string;
  onReady: () => Promise<boolean | { sent: boolean; reason?: string }>;
}

/** 资料包会话的同步交接卡。状态机已泛化到 `SyncHandoff`（EDG-561），本组件只固定 `kind`。 */
export function ThemePackChatHandoff({ onReady, themeId, chatId }: Props) {
  return (
    <SyncHandoff
      kind="theme_pack"
      themeId={themeId}
      chatId={chatId}
      onReady={onReady}
    />
  );
}
